/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterInfosDto } from '../../models/mitarbeiter-infos-dto';

export interface GetAllMitarbeiterAggregated$Json$Params {
  Units?: Array<string>;
  Kostenstelle?: string;
  TarifAttribut?: string;
  AttributId?: string;
  Monat?: string;
  Saldovortrag?: boolean;
}

export function getAllMitarbeiterAggregated$Json(http: HttpClient, rootUrl: string, params?: GetAllMitarbeiterAggregated$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterInfosDto>> {
  const rb = new RequestBuilder(rootUrl, getAllMitarbeiterAggregated$Json.PATH, 'get');
  if (params) {
    rb.query('Units', params.Units, {});
    rb.query('Kostenstelle', params.Kostenstelle, {});
    rb.query('TarifAttribut', params.TarifAttribut, {});
    rb.query('AttributId', params.AttributId, {});
    rb.query('Monat', params.Monat, {});
    rb.query('Saldovortrag', params.Saldovortrag, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterInfosDto>;
    })
  );
}

getAllMitarbeiterAggregated$Json.PATH = '/v1/mitarbeiter/aggregated';
